module.exports = __webpack_public_path__ + "img/ksm.3379e4de.svg";